import { BASE_URL } from '../shared/consts/baseUrl';

export const MENUITEMS = [
    {
        menutitle: "Dashboards",
        Items: [
            { path: `${BASE_URL}dashboard`, icon: 'fe fe-trending-up', type: 'link', active: false, selected: false, title: 'Главный' },
            
            { path: `${BASE_URL}dashboard/marja`, icon: 'fe fe-trending-up', type: 'link', active: false, selected: false, title: 'Маржа' },
            { path: `${BASE_URL}dashboard/convertion`, icon: 'fe fe-trending-up', type: 'link', active: false, selected: false, title: 'Конверсия' },
        ]
    },

    {
        menutitle: "Бизнес продукты",
        Items: [
            { path: `${BASE_URL}merchant/list`, icon: 'fe fe-briefcase', type: 'link', active: false, selected: false, title: 'Продукты (Мерчанты)' },
            { path: `${BASE_URL}provider/list`, icon: 'fe fe-shuffle', type: 'link', active: false, selected: false, title: 'Провайдеры' },
            // { path: `${BASE_URL}rate/list`, icon: 'fe fe-home', type: 'link', active: false, selected: false, title: 'Тарифы' },
        ]   
    },






    {
        menutitle: "Операции",
        id: 6,
        Items: [
            {
                path: `${BASE_URL}operation/list`, 
                icon:'fe fe-layers',
                type: 'link',
                active: false,
                selected: false,
                title: 'Все операции',
            },

            {
                path: `${BASE_URL}operation/payin/list`, 
                icon:'fe fe-download',
                type: 'link',
                active: false,
                selected: false,
                title: 'Pay in',
            },

            {
                path: `${BASE_URL}operation/payout/list`, 
                icon:'fe fe-upload',
                type: 'link',
                active: false,
                selected: false,
                title: 'Pay out',
            },
        ]

        },

    {
        menutitle: "Контрагенты",
        Items: [
            {
                path: `${BASE_URL}contragent/list`,
                icon: 'fe fe-user-check',
                type: 'link',
                active: false,
                selected: false,
                title: 'КА',
            },
        ]
    },





        {
            menutitle: "Документы баланса",
            id: 6,
            Items: [
                {
                    path: `${BASE_URL}operationbalance/list`,
                    icon:'fe fe-arrow-up-right',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: 'Поступление/Вывод',
                },
                {
                    path: `${BASE_URL}balances`,
                    icon: 'fe fe-bar-chart-2',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: 'Балансы',
                },
            ]

        },


        {
            menutitle: "Пользователи",
            Items: [
                { path: `${BASE_URL}user/list`, icon: 'fe fe-users', type: 'link', active: false, selected: false, title: 'Пользователи' },
            ]   
        },


        {
            menutitle: "Справочники",
            id: 7,
            Items: [
                {
                    path: `${BASE_URL}bank/list`, 
                    icon:'fe fe-arrow-up-right',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: 'Банки',
                },
                {
                    path: `${BASE_URL}banknamevariant/list`, 
                    icon:'fe fe-arrow-down-right',
                    type: 'link',
                    active: false,
                    selected: false,
                    title: 'Варианты имен банков',
                },
            ]
        
        },



        
        
        
        
]